module.exports = __webpack_public_path__ + "media/4x3/gs-0ee2d8c9.svg";